import { gql } from 'graphql-request';

export const DestroyImage = gql`
  mutation DestroyImage($image:DestroyImageInput!) {
    destroyImage(input:$image) {
      id
      errors {
        fieldName
        errors
      }
    }
  }
`;
